import Vue from 'vue';
import Router from 'vue-router';

import AddDocument from './views/AddDocuments/AddDocument.vue';
import AddNew from './views/AddNew/AddNew.vue';
import Draft from './views/Document/Draft/Draft.vue';
import Section from './views/Document/Section/Section.vue';
import aboutConsenz from './views/NavBar/AboutConsenz.vue';
import aboutDocument from './views/NavBar/AboutDocument.vue';
import contactUs from './views/NavBar/ContactUs.vue';
import NavBar from './views/NavBar/NavBar.vue';
import EnteringPage from "./views/EnteringPage/EnteringPage.vue";
import LandingPage from "./views/LandingPage/LandingPage.vue";
import ChooseTopics from "@/views/Document/ChooseTopicsPage/ChooseTopicsPage.vue";
import TopicsSelectedList from "@/views/Document/TopicsSelectedList/TopicsSelectedList.vue";
import Vote from "@/views/Document/Vote/Vote";
import EventActivity from "@/views/Document/EventActivity/EventActivity";
import UsersListPage from "@/views/Document/UsersListPage/UsersListPage.vue";

Vue.use(Router);

export const routes = [
  {
    path: '/',
    name: 'home',
    component: NavBar,
    children: [
      {
        path: '/',
        name: 'welcome',
        component: EnteringPage,
      },
      {
        path: '/aboutConsenz',
        name: 'aboutConsenz',
        component: aboutConsenz,
      },
      {
        path: '/aboutDocument',
        name: 'aboutDocument',
        component: aboutDocument,
      },
      {
        path: '/contactUs',
        name: 'contactUs',
        component: contactUs,
      },
      {
        path: '/document/:prettyLink/draft',
        name: 'draft',
        component: Draft,
      },
      {
        path: '/document/:prettyLink/addNew',
        name: 'addNew',
        component: AddNew,
        meta: { requiresAuth: true },
      },
      {
        path: '/document/:prettyLink/section/:parentSectionId?/:sectionId?/:pageStatus?',
        name: 'section',
        component: Section,
        meta: { requiresAuth: true },
      },
      {
        path: '/addDocument',
        name: 'AddDocument',
        component: AddDocument,
        meta: { requiresAuth: true },
      },
      {
        path: "/document/:prettyLink/welcome",
        name: "welcome",
        component: EnteringPage,
      },
      {
        path: "/document/:prettyLink/choosetopics",
        name: "choosetopics",
        component: ChooseTopics,
      },
      {
        path: "/document/:prettyLink/selectedlist",
        name: "selectedlist",
        component: TopicsSelectedList,
      },
      {
        path: "/document/:prettyLink/vote",
        name: "vote",
        component: Vote,
      },
      {
        path: "/document/:prettyLink/event",
        name: "event",
        component: EventActivity,
      },
      {
        path: "/document/:prettyLink/userslist",
        name: "usersList",
        component: UsersListPage,
      }
    ],
  },
  {
    path: '/landingPage',
    name: 'landingPage',
    component: LandingPage,
  },
];

export let router = new Router({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

router.beforeEach((to, from, next) => {
  // Redirect if fullPath begins with a hash (ignore hashes later in path)
  if (to.fullPath.substr(0,2) === "/#") {
    const path = to.fullPath.substr(2); next(path); return;
  }
  next();
})


// # sourceMappingURL=router.js.map
